export const reportTableConfig = {
  needPagination: true, // 是否需要分页
  fluidHeight: false, // 流体高度
  showOrdinal: false, // 是否显示序号,
  frontEndPaging: true, //前端分页
  count: "total",
  resultListName: "records",
  params: [
    {
      prop: "ssoSupplierOrderNo",
      label: "报工单号",
    },
    {
      prop: "projectName",
      label: "项目名称",
    },
    {
      prop: "demandTableNo",
      label: "申请单号",
    },
    {
      prop: "projectManager",
      label: "项目经理",
    },
    {
      prop: "deviceName",
      label: "装置名称",
    },
    {
      prop: "workDescription",
      label: "工作内容",
      showOverflowTooltip: true,
    },
    {
      prop: "workStatusStr",
      label: "工作状态",
    },
    {
      prop: "deliveryNum",
      label: "工时(小时)",
    },
    {
      prop: "deliveryNumPerDay",
      label: "工时(人/天)",
    },
    {
      prop: "supplierOrderCreateTime",
      label: "填报日期",
    },
    {
      prop: "operation",
      label: "操作",
      isSlot: true,
    },
  ],
};

export const costTableConfig = {
  needPagination: true, // 是否需要分页
  fluidHeight: false, // 流体高度
  showOrdinal: false, // 是否显示序号,
  frontEndPaging: true, //前端分页
  count: "total",
  resultListName: "records",
  params: [
    {
      prop: "deviceName",
      label: "装置名称",
    },
    {
      prop: "transportationExpenses",
      label: "交通费",
      valueType: "money",
      isSlot: true,
    },

    {
      prop: "transportationFoList",
      label: "交通费附件",
      isSlot: true,
    },

    {
      prop: "operation",
      label: "操作",
      isSlot: true,
    },
  ],
};
